module.exports = g_errstr3D;